/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import { useNavigate } from 'react-router-dom'
import { Text, useNotification } from '@az/starc-ui'

import { t } from 'i18next'
import StorePositionScreen from './StorePosition/StorePosition'
import StoreInput from './StoreInput/StoreInput'

function LandingPage() {
  const notification = useNotification()
  const navigate = useNavigate()
  const showNotification = () => {
    const id = notification.show({
      type: 'error',
      title: t('wrong-store') as string,
      text: t('enter-twice') as string,
      hasCloseButton: true,
      closeButtonTitle: 'close',
      onClose: () => notification.hide(id)
    })
  }

  return (
    <>
      <StorePositionScreen
        setStore={(store: string) => {
          if (store != null && store !== '') {
            navigate(`/storedetails/${store}`)
          }
        }}
      ></StorePositionScreen>
      <Text align="center" color="200" size="200" lineHeight="125">
        {t('or') as string}
      </Text>
      <StoreInput
        showErrorNotification={showNotification}
        setStore={(store: string) => {
          if (store != null && store !== '') {
            navigate(`/storedetails/${store}`)
          }
        }}
      />
    </>
  )
}

export default LandingPage
